import morph from "../helpers/morph";
import "./product-card-gallery";
import "./product-card-swatches";

const getData = (productUrl) => {
  return fetch(`${productUrl}?section_id=product-card-content`)
    .then(res => res.text())
    .then(markup => {
      const html = new DOMParser().parseFromString(markup, "text/html");
      return JSON.parse(html.querySelector('script').innerHTML);
    });
}

class ProductCard extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.addEventListener('change', (e) => {
      this._changeContent(e.target.value);
    });
  }

  disconnectedCallback() {

  }

  _changeContent(productId) {
    this._loadData().then(data => {
      morph(this, data.products[productId].product_card);
    });
  }

  _loadData() {
    if (this.data) return Promise.resolve(this.data);
    if (this.loadingData) return this.loadingData;

    this.loadingData =
      getData(this.productUrl)
        .then(data => {
          this.data = data

          const missingProducts = Object.entries(this.data.products).filter(([_, product]) => product.product_card === null);

          // Sometimes, if there is a mismatch in product options, product data is not
          // directly available via Combined Listings. To cover those cases we need to
          // individually fetch the missing data.
          if (missingProducts.length) {
            return Promise.all(missingProducts.map(([id, missingProduct]) => {
              return new Promise(async (resolve) => {
                const { current } = await getData(missingProduct.product_url);

                this.data.products[id].product_card = current;

                resolve();
              });
            }));
          }

          return Promise.resolve();
        })
        .then(() => this.data);

    return this.loadingData;
  }

  get productUrl() {
    return this.getAttribute('product-url');
  }
}

if (!customElements.get("product-card")) {
  customElements.define("product-card", ProductCard);
}
